import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/sections/Navigation";
import { Footer } from "@/components/sections/Footer";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div className={`min-h-screen ${isRTL ? "rtl" : "ltr"}`}>
      <Navigation isRTL={isRTL} setRegistrationType={() => {}} handleRegistrationClick={() => {}} />
      
      <div className="container max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-primary hover:underline mb-8">
          <ArrowRight className={`w-4 h-4 ${isRTL ? "" : "rotate-180"}`} />
          {isRTL ? "العودة للرئيسية" : "Back to Home"}
        </Link>

        <h1 className="text-3xl font-bold text-foreground mb-8">
          {isRTL ? "الشروط والأحكام" : "Terms of Service"}
        </h1>

        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          {isRTL ? (
            <>
              <section>
                <h2 className="text-xl font-semibold text-foreground">القبول بالشروط</h2>
                <p>باستخدامك لمنصة "دليل يدل - Yadel"، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه الشروط، يرجى عدم استخدام المنصة.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">وصف الخدمة</h2>
                <p>دليل يدل هي منصة إلكترونية شاملة لعرض وتغطية الفعاليات والمواسم السعودية، تشمل المعارض والمؤتمرات والندوات والمهرجانات والمناسبات العامة.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">حسابات المستخدمين</h2>
                <ul className="list-disc pr-6 space-y-2">
                  <li>يجب أن تكون المعلومات المقدمة عند التسجيل دقيقة وكاملة</li>
                  <li>أنت مسؤول عن الحفاظ على سرية حسابك وكلمة المرور</li>
                  <li>يجب إخطارنا فوراً في حالة أي استخدام غير مصرح به لحسابك</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">المحتوى المقدم من المستخدمين</h2>
                <ul className="list-disc pr-6 space-y-2">
                  <li>أنت مسؤول عن أي محتوى تقدمه عبر المنصة</li>
                  <li>يجب ألا يكون المحتوى مخالفاً للقوانين أو مسيئاً</li>
                  <li>نحتفظ بالحق في إزالة أي محتوى يخالف شروطنا</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">الملكية الفكرية</h2>
                <p>جميع المحتويات والتصاميم والعلامات التجارية على المنصة هي ملك لشركة MDYAF ALARABIA CO ومحمية بموجب قوانين الملكية الفكرية.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">إخلاء المسؤولية</h2>
                <p>نسعى لتقديم معلومات دقيقة عن الفعاليات، لكننا لا نضمن دقة أو اكتمال جميع المعلومات المعروضة. المنظمون هم المسؤولون عن تفاصيل فعالياتهم.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">التعديلات</h2>
                <p>نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطارك بأي تغييرات جوهرية عبر المنصة أو البريد الإلكتروني.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">القانون الحاكم</h2>
                <p>تخضع هذه الشروط لأنظمة وقوانين المملكة العربية السعودية.</p>
              </section>

              <p className="text-sm text-muted-foreground mt-8">آخر تحديث: مارس 2026</p>
            </>
          ) : (
            <>
              <section>
                <h2 className="text-xl font-semibold text-foreground">Acceptance of Terms</h2>
                <p>By using the "Yadel" platform, you agree to comply with these Terms of Service. If you do not agree to any of these terms, please do not use the platform.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">Service Description</h2>
                <p>Yadel is a comprehensive online platform for showcasing and covering Saudi events and seasons, including exhibitions, conferences, seminars, festivals, and public occasions.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">User Accounts</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Information provided during registration must be accurate and complete</li>
                  <li>You are responsible for maintaining the confidentiality of your account and password</li>
                  <li>You must notify us immediately of any unauthorized use of your account</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">User-Submitted Content</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>You are responsible for any content you submit through the platform</li>
                  <li>Content must not violate laws or be offensive</li>
                  <li>We reserve the right to remove any content that violates our terms</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">Intellectual Property</h2>
                <p>All content, designs, and trademarks on the platform are owned by MDYAF ALARABIA CO and protected under intellectual property laws.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">Disclaimer</h2>
                <p>We strive to provide accurate event information, but we do not guarantee the accuracy or completeness of all displayed information. Organizers are responsible for their event details.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">Modifications</h2>
                <p>We reserve the right to modify these terms at any time. You will be notified of any material changes via the platform or email.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground">Governing Law</h2>
                <p>These terms are governed by the laws and regulations of the Kingdom of Saudi Arabia.</p>
              </section>

              <p className="text-sm text-muted-foreground mt-8">Last updated: March 2026</p>
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfService;
